module.exports = __webpack_public_path__ + "img/end_tb_logo.d1d83dfb.png";